let enableUpcomingContent = process.env.NEXT_PUBLIC_ENABLE_UPCOMING_CONTENT;
let noteworthyContentApiUrl = process.env.NEXT_PUBLIC_NOTEWORTHY_CONTENT_API_URL;
let pod = process.env.NEXT_PUBLIC_POD;
let assetPath = process.env.NEXT_PUBLIC_ASSET_PATH;
let assetRoutePrefix = process.env.NEXT_PUBLIC_ASSET_ROUTE_PREFIX;
if (!assetRoutePrefix || assetRoutePrefix.substring(1) === '{ASSET_ROUTE_PREFIX}') {
  assetRoutePrefix = process.env.ASSET_ROUTE_PREFIX || '/noteworthy'; // this is a required fallback (specific to this app), because of how var substitution is set up here
}
const serviceName = process.env.NEXT_PUBLIC_DD_SERVICE;
const debugVersion = process.env.NEXT_PUBLIC_DEBUG_VERSION;
const currentEnvironment = process.env.NEXT_PUBLIC_CURRENT_ENVIRONMENT;

module.exports = {
  app: 'noteworthy',
  enableUpcomingContent,
  noteworthyContentApiUrl,
  pod,
  assetRoutePrefix,
  assetPath,
  serviceName,
  debugVersion,
  currentEnvironment
};
